/**
 * @file default-group.form.tsx
 * @description Форма для создания и редактирования групп по умолчанию в системе.
 * Включает поля для указания наименования группы и родительской группы.
 * Поддерживает иерархическую структуру групп через выбор родительской группы.
 * Интегрируется с react-hook-form через control prop.
 * @author AI Assistant
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, @components/form-controls/text-field, @src/types, @components/form-controls/dictionary]
 * @related-files [@components/form-controls/text-field/text-field.component.tsx, @components/form-controls/dictionary/dictionary.component.tsx]
 */

import { TextField } from '@components/form-controls/text-field';
import { BaseForm } from '@src/types';
import { Dictionary } from '@components/form-controls/dictionary';

export const Form = ({ control }: BaseForm) => {
    return (
        <div className="flex flex-col gap-default">
            <TextField name="name" label="Наименование" className="w-[37.5874vmin]" control={control} />
            
            <Dictionary name="parent" label="Группа" width="37.5874vmin" control={control} />
        </div>
    );
};
